import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const HIERARCHY_FIELDS = [
  { id: "supervisor_id", labelKey: "employeesPage.labels.supervisor", placeholderKey: "employeesPage.placeholders.supervisor" },
  { id: "coach_id",      labelKey: "employeesPage.labels.coach",      placeholderKey: "employeesPage.placeholders.coach" },
  { id: "mentor_id",     labelKey: "employeesPage.labels.mentor",     placeholderKey: "employeesPage.placeholders.mentor" },
];

const EmployeeHierarchySection = ({ formData, updateField, employees }) => {
  const { t } = useTranslation();
  const activeEmployees = employees.filter((e) => e.status === "ACTIVE");

  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Users className="h-4 w-4" />
        <span>{t("employeesPage.sections.hierarchy")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        {HIERARCHY_FIELDS.map(({ id, labelKey, placeholderKey }) => (
          <div key={id} className="space-y-2">
            <Label htmlFor={id}>{t(labelKey)}</Label>
            <Select value={formData[id]} onValueChange={(v) => updateField(id, v)}>
              <SelectTrigger><SelectValue placeholder={t(placeholderKey)} /></SelectTrigger>
              <SelectContent className="max-h-60 overflow-y-auto">
                {activeEmployees.map((emp) => (
                  <SelectItem key={emp.id} value={emp.id.toString()}>
                    {emp.full_name}{emp.job_name ? ` (${emp.job_name})` : ""}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployeeHierarchySection;
